import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const createSystemVendorInvoice = async ({ formData, serviceItemsData, sites }) => {
  try {
    const fd = new FormData();

    // Required file
    if (formData?.poFile) {
      fd.append('poFile', formData.poFile);
    }

    // Scalar fields (keep names aligned with backend controller expectations)
    fd.append('vendor', formData?.vendor || '');
    fd.append('poNumber', formData?.poNumber || '');
    fd.append('poDate', formData?.poDate || '');
    fd.append('deliverDate', formData?.deliverDate || '');
    fd.append('invoiceNumber', formData?.invoiceNumber || '');
    fd.append('invoiceAmount', formData?.invoiceAmount || '');
    fd.append('category', formData?.category || '');
    fd.append('paymentMilestone', formData?.paymentMilestone || '');
    fd.append('invoiceType', formData?.invoiceType || '');
    fd.append('type', formData?.poType || formData?.type || '');
    fd.append('region', formData?.region || '');
    fd.append('submittersEmail', formData?.submittersEmail || '');
    fd.append('atpStatus', formData?.atpStatus || '');
    fd.append('pacStatus', formData?.pacStatus || '');
    fd.append('facStatus', formData?.facStatus || '');
    fd.append('remainingPOAmount', formData?.remainingPOAmount || '');
    fd.append('vendorRemarks', formData?.vendorRemarks || '');

    // JSONB fields
    fd.append('service_items_data', JSON.stringify(serviceItemsData || []));
    fd.append('sites', JSON.stringify(sites || []));

    // Other documents
    (formData?.otherDocuments || []).forEach((file) => {
      fd.append('otherDocuments', file);
    });

    const response = await apiClient.post('/systemVendorInvoiceManagement/invoice/create', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
